const COLUMNS = [
  ["Received", (e) => e.created_at],
  ["Parent name", (e) => e.name],
  ["Email", (e) => e.email],
  ["Phone", (e) => e.phone],
  ["Children", (e) => e.children],
  ["Classes of interest", (e) => (e.classes && e.classes.length ? e.classes.join("; ") : e.program)],
  ["Preferred days", (e) => (e.days || []).join("; ")],
  ["How they found us", (e) => e.heard_from],
  ["Recommended by", (e) => e.referred_by],
  ["Message", (e) => e.message],
  ["Status", (e) => (e.replied ? "Replied" : "Awaiting reply")],
  ["Replied at", (e) => e.replied_at],
  ["Private note", (e) => e.note],
];

const cell = (v) => {
  const s = v == null ? "" : String(v);
  // Neutralise spreadsheet formula injection, then quote.
  const safe = /^[=+\-@\t\r]/.test(s) ? `'${s}` : s;
  return `"${safe.replace(/"/g, '""')}"`;
};

export function enquiriesToCsv(list) {
  const header = COLUMNS.map(([h]) => cell(h)).join(",");
  const rows = list.map((e) => COLUMNS.map(([, fn]) => cell(fn(e))).join(","));
  return "\uFEFF" + [header, ...rows].join("\r\n"); // BOM so Excel opens UTF-8 correctly
}

export function downloadCsv(list, filenameHint = "enquiries") {
  const blob = new Blob([enquiriesToCsv(list)], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `happy-tiddlers-${filenameHint}-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
